/**
 * @Author: abbeymart | Abi Akindele | @Created: 2016-12-21 | @Updated: 2019-04-04
 * @Company: mConnect.biz | @License: MIT
 * @Description: mc-others routes - access-denied, not-found etc.
 */

import type { RouteRecordRaw } from 'vue-router';

export const otherRoutes: Array<RouteRecordRaw> = [
  {
    path: '/access-denied',
    name: 'accessDenied',
    component: () => import('components/app-shared/AccessDenied.vue'),
  },
  {
    path: '/*',
    name: 'notFound',
    component: () => import('components/app-shared/NotFound.vue'),
  },
];
